
__webpack_require__.debugRequireIds = {
	"-!./debug-require.cjs": 2800,
	"./debug-require.cjs": 82901,
	"./src/base_page_params.ts": 88585,
	"./src/blueslip.ts": 67463,
	"./src/blueslip_stacktrace.ts": 65047,
	"./src/bot_types.ts": 20154,
	"./src/bundles/common.ts": 48422,
	"./src/bundles/marketing_page_bundle.ts": 84472,
	"./src/csrf.ts": 58315,
	"./src/portico/google-analytics.ts": 50762,
	"./src/portico/header.ts": 95893,
	"./src/realm_user_settings_defaults.ts": 69757,
	"./src/sentry.ts": 92522,
	"./src/state_data.ts": 39307,
	"./src/stream_types.ts": 12287,
	"./src/types.ts": 97620,
	"./src/user_settings.ts": 56748,
	"./src/user_status_types.ts": 86077,
	"./styles/portico/comparison_table.css": 87803,
	"./styles/portico/marketing_page.css": 14771,
	"./styles/portico/pricing_plans.css": 56178,
	"./templates/blueslip_stacktrace.hbs": 97825,
	"./templates/team/contributor_count.hbs": 36993,
	"./templates/team/contributors.hbs": 10175,
	"./templates/team/loading.hbs": 22581,
	"./templates/team/total_contributor_count.hbs": 90185,
	"core-js/modules/es.array.includes.js": 54508,
	"core-js/modules/es.iterator.constructor.js": 16608,
	"core-js/modules/es.iterator.filter.js": 79944,
	"core-js/modules/es.iterator.find.js": 70001,
	"core-js/modules/es.iterator.flat-map.js": 27454,
	"core-js/modules/es.iterator.map.js": 72542,
	"core-js/modules/es.iterator.reduce.js": 79992,
	"core-js/modules/es.iterator.some.js": 75390,
	"core-js/modules/es.json.parse.js": 9999,
	"core-js/modules/es.json.stringify.js": 27761,
	"core-js/modules/es.map.get-or-insert-computed.js": 47180,
	"core-js/modules/es.map.get-or-insert.js": 40870,
	"core-js/modules/es.set.difference.v2.js": 93535,
	"core-js/modules/es.set.intersection.v2.js": 2665,
	"core-js/modules/es.set.is-disjoint-from.v2.js": 18052,
	"core-js/modules/es.set.is-subset-of.v2.js": 92025,
	"core-js/modules/es.set.is-superset-of.v2.js": 54402,
	"core-js/modules/es.set.symmetric-difference.v2.js": 36617,
	"core-js/modules/es.set.union.v2.js": 54725,
	"core-js/modules/es.typed-array.with.js": 10722,
	"core-js/modules/es.uint8-array.set-from-base64.js": 61693,
	"core-js/modules/es.uint8-array.set-from-hex.js": 48789,
	"core-js/modules/es.uint8-array.to-base64.js": 33775,
	"core-js/modules/es.uint8-array.to-hex.js": 72791,
	"error-stack-parser": 69363,
	"ga-gtag": 78406,
	"handlebars/runtime.js": 38417,
	"jquery": 63150,
	"lodash": 35558,
	"minimalistic-assert": 45185,
	"source-map": 68068,
	"stackframe": 36854,
	"stacktrace-gps": 14021,
	"zod/mini": 15729
};